/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddLineItemModel } from './AddLineItemModel';
import {
    AddLineItemModelFromJSON,
    AddLineItemModelFromJSONTyped,
    AddLineItemModelToJSON,
} from './AddLineItemModel';

/**
 * 
 * @export
 * @interface AddBasketLineItemsModel
 */
export interface AddBasketLineItemsModel {
    /**
     * 
     * @type {AddLineItemModel}
     * @memberof AddBasketLineItemsModel
     */
    groupLine?: AddLineItemModel;
    /**
     * 
     * @type {string}
     * @memberof AddBasketLineItemsModel
     */
    replaces?: string;
    /**
     * 
     * @type {Array<AddLineItemModel>}
     * @memberof AddBasketLineItemsModel
     */
    lines?: Array<AddLineItemModel>;
}

/**
 * Check if a given object implements the AddBasketLineItemsModel interface.
 */
export function instanceOfAddBasketLineItemsModel(value: object): boolean {
    return true;
}

export function AddBasketLineItemsModelFromJSON(json: any): AddBasketLineItemsModel {
    return AddBasketLineItemsModelFromJSONTyped(json, false);
}

export function AddBasketLineItemsModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddBasketLineItemsModel {
    if (json == null) {
        return json;
    }
    return {
        
        'groupLine': json['groupLine'] == null ? undefined : AddLineItemModelFromJSON(json['groupLine']),
        'replaces': json['replaces'] == null ? undefined : json['replaces'],
        'lines': json['lines'] == null ? undefined : ((json['lines'] as Array<any>).map(AddLineItemModelFromJSON)),
    };
}

export function AddBasketLineItemsModelToJSON(value?: AddBasketLineItemsModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'groupLine': AddLineItemModelToJSON(value['groupLine']),
        'replaces': value['replaces'],
        'lines': value['lines'] == null ? undefined : ((value['lines'] as Array<any>).map(AddLineItemModelToJSON)),
    };
}

